
export const BASE_URL_HARDWARES =   process.env.REACT_APP_BACKEND_API_URL + "/api/v1/hardwares";

const harwaresAPI = {

}

export default harwaresAPI;
